import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
    IScheduleStatusResponse,
    IScheduleDetailsResponse,
    IScheduleDetailsV2Response,
    IScheduleRequest,
    IRiskLocationDetailsResponse,
    IScheduleDetailsPageResponse,
    ICountryData,
    InputFieldsResponse,
    InputFieldsRequestPayload,
    IGetScheduleRequest,
    IGetScheduleTaxBreakupRequest,
    IUpdateScheduleResponse,
    ICountry,
    IApportionmentResponse,
    IApportionmentSaveRequest,
    IApportionmentSaveResponse,
    IApportionmentClientLobResponse,
    IApportionmentTaxData,
    IApportionmentPerLayerRequest,
    IUploadTaxScheduleJsonResponse,
    IUploadJsonRequest,
    IJurisdictionRequest,
    IGetScheduleStatusRequest,
    ILobVariationResponse,
    ILobVariationRequest,
    IClassVariationResponse,
    IClassVariationRequest,
    IUploadDTSchedulePDFRequest,
    IUploadDTSchedulePDFResponse,
} from '../types/schedule.type';
import scheduleDetailsServices from '../services/scheduleDetailsService';
import { ApiState } from '../constants/enums';
import { IApportionmentLocation, ICurrency, ICurrencyResponse, ILocationData, IRegions, IRegionsRepsonse, ISubRegions, ISubRegionsRepsonse } from '../types/rate.type';
import { ILayerDetailsReq, ILocalPolicy, IScheduleLayers, IScheduleLayersResponse } from '../types/insurerjurisdiction.type';
import {
    IClassInputDetails,
} from '../../app/components/apportionment/percentage/ClassTypeVariationsApportionment';
import {
    IApportionmentData,
} from '../../app/components/apportionment/percentage/types';
import { ClientSubLobs } from './rateFinderSlice';
import { IClientLobApportionmentData } from '../../app/components/apportionment/percentage/ClientLobApportionment';
import { format } from 'date-fns';
import { IError } from '../types/admin.type';
import rateFinderServices from '../services/rateFinderServices';
export interface ScheduleDetailsState {
    scheduleId: number;
    formFields: IFormField;
    riskLocationDetails: IRiskLocationDetailsResponse[];
    jurisdictionDetails?: IRiskLocationDetailsResponse[];
    inputFields: ICountry[];
    apiState: {
        saveScheduleDetails: ApiState;
        postTaxSchedules: ApiState;
        getInputFields: ApiState;
        getScheduleStatusUpdate: ApiState;
        getScheduleDetails: ApiState;
        getScheduleDetailsV2: ApiState;
        getScheduleTaxBreakup: ApiState;
        getScheduleLayerDetails: ApiState;
        updateScheduleDetails: ApiState;
        updateApportionmentDetails: ApiState;
        updateApportionmentDetailsV2: ApiState;
        updateJurisdictionDetails: ApiState;
        getApportionmentTaxDetails: ApiState;
        updateApportionmentPerLayer: ApiState;
        uploadTaxScheduleJson: ApiState;
        uploadDTSchedulePDF: ApiState;
        updateVariationApportionment: ApiState;
        getLobVariationData: ApiState;
        getClassVariationData: ApiState;
        getRiskLocationRegions: ApiState;
        getRiskLocationSubRegions: ApiState;
        getCurrencyList: ApiState;
        
    };
    policyCurrency : ICurrency[];
    locationDetails: ILocationData[];
    apportionmentDetails: IApportionmentData;
    apportionmentData: IApportionmentData;
    localPolicyApportionmentData: IApportionmentData;
    apportionmentClientLobDetails: IClientLobApportionmentData;
    apportionmentInputDetails: ICountryData[];
    variationApportionment: IUpdateVariationApportionmentRequest;
    VariationsApportionmentUI: IApportionmentData;
    isApportionmentAccordianOpen: boolean[];
    scheduleLayers: IScheduleLayers[];
    formFieldsForJurisdictionPage: IFormFieldInsurerIdentification;
    details?: any;
    taxBreakup?: any;
    formValueOnStepOneSubmit: IFormField;
    updateSchedulesResponse: IUpdateScheduleResponse;
    updateSchedulesResponseV2: IApportionmentSaveResponse;
    getLobVariationData: ILobVariationResponse;
    getClassVariationData: IClassVariationResponse;
    getRiskLocationRegions: IRegionsRepsonse;
    getRiskLocationSubRegions: ISubRegionsRepsonse;
    showRadioButton: boolean;
    isLoaderVisibile: boolean;
    draftDetailsPage: boolean;
    draftCoveragePage: boolean;
    draftInsurersPage: boolean;
    infoMessageVisible: boolean;
    errorMessageVisible: boolean;
    warningMessageVisible: boolean;
    scheduleWarningVisible: boolean;
    scheduleWarningMessage: string;
    errorMessage: string;
    draftApportionmentPage: boolean;
    draftPercentageEdit: boolean;
    insurerValuesOnSubmit: IFormFieldInsurerIdentification;
    selectedInsClasses: IClassInputDetails[];
    selectedRiskLocations: IApportionmentLocation;
    apportionmentTaxData: IApportionmentTaxData[];
    selectedSubLob: ClientSubLobs;
    uploadJsonVisible: boolean;
    uploadTaxScheduleResponse?: IUploadTaxScheduleJsonResponse;
    uploadDTSchedulePDFResponse?: IUploadDTSchedulePDFResponse;
    updateVariationApportionment: IResultsResponse;
    updateJurisdictionDetails: IResultsResponse;
    error: IError;
    variationApportionmentActiveCountry: string;
    variationApportionmentLocalPolicyActiveCountry: string;
    isNavigateButtonClicked: boolean;
    variationApportionmentValidation: boolean;

}

export interface IResultsResponse{
    data: {
        message: string;
    };
}
export interface IFormField {
    name: string;
    description?: string;
    policyNumber: string;
    effectiveDate: string;
    expiryDate: string;
    umr: string;
    policyHolderLocation: string;
    currency: string;
    lob: string[];
    class: string[];
}

export const initialJurisdictionFormData = {
    apportionmentMethod: '',
    currency: '',
    layerCount: '',
    insurerDetails: [
        {
            fromValue: '0',
            toValue: '',
            premiumAmt: '',
            insurer: [
                {
                    isDeleted: false,
                    insurerName: '',
                    coveragePercenage: '',
                    location: '',
                    isLeadInsurer: false,
                    insurerStatus: [
                        {
                            countryName: '',
                            regionName: '',
                            subRegionName: '',
                            isAdmitted: '',
                            regionId: null,
                            subRegionId: null,
                            countryCode: '',
                        },
                    ],
                },
            ],

            sumAssured: '',
        },
    ],
    localPolicy: [
        // {
        //     taxCalculationRequired: false,
        //     insuredName: '',
        //     policyCurrency: '',
        //     insurerName: '',
        //     insurerLocation: '',
        //     countryCode: '',
        //     countryName: '',
        //     regionId: '',
        //     regionName: '',
        //     subRegionId: '',
        //     subRegionName: '',
        //     premiumAmount: '',
        // },
    ],
};

const initialState: ScheduleDetailsState = {
    riskLocationDetails: [],
    jurisdictionDetails: [],
    apiState: {
        saveScheduleDetails: ApiState.NOT_STARTED,
        postTaxSchedules: ApiState.NOT_STARTED,
        getInputFields: ApiState.NOT_STARTED,
        getScheduleStatusUpdate: ApiState.NOT_STARTED,
        getScheduleDetails: ApiState.NOT_STARTED,
        getScheduleDetailsV2: ApiState.NOT_STARTED,
        getScheduleTaxBreakup: ApiState.NOT_STARTED,
        getScheduleLayerDetails: ApiState.NOT_STARTED,
        updateScheduleDetails: ApiState.NOT_STARTED,
        updateApportionmentDetails: ApiState.NOT_STARTED,
        updateApportionmentDetailsV2: ApiState.NOT_STARTED,
        updateJurisdictionDetails: ApiState.NOT_STARTED,
        getApportionmentTaxDetails: ApiState.NOT_STARTED,
        updateApportionmentPerLayer: ApiState.NOT_STARTED,
        uploadTaxScheduleJson: ApiState.NOT_STARTED,
        uploadDTSchedulePDF: ApiState.NOT_STARTED,
        updateVariationApportionment: ApiState.NOT_STARTED,
        getLobVariationData: ApiState.NOT_STARTED,
        getClassVariationData: ApiState.NOT_STARTED,
        getRiskLocationRegions: ApiState.NOT_STARTED,
        getRiskLocationSubRegions: ApiState.NOT_STARTED,
        getCurrencyList: ApiState.NOT_STARTED,
    },
    formValueOnStepOneSubmit: {
        name: '',
        description: '',
        policyNumber: '',
        effectiveDate: '',
        expiryDate: '',
        umr: '',
        policyHolderLocation: '',
        currency: '',
        lob: [],
        class: [],
    },
    scheduleId: 0,
    formFields: {
        name: '',
        description: '',
        policyNumber: '',
        effectiveDate: '',
        expiryDate: '',
        umr: '',
        policyHolderLocation: '',
        currency: '',
        lob: [],
        class: [],
    },
    inputFields: [],
    locationDetails: [],
    apportionmentDetails: {} as IApportionmentData,
    apportionmentData: {} as IApportionmentData,
    localPolicyApportionmentData: {} as IApportionmentData,
    apportionmentClientLobDetails: {} as IClientLobApportionmentData,
    details: {},
    taxBreakup: {},
    apportionmentInputDetails: [],
    variationApportionment: {} as IUpdateVariationApportionmentRequest,
    VariationsApportionmentUI: {} as IApportionmentData,
    updateSchedulesResponseV2: {} as IApportionmentSaveResponse,
    getLobVariationData: {} as ILobVariationResponse,
    getClassVariationData: {} as IClassVariationResponse,
    getRiskLocationRegions: {} as IRegionsRepsonse,
    getRiskLocationSubRegions: {} as ISubRegionsRepsonse,
    isApportionmentAccordianOpen: [],
    scheduleLayers: [],
    formFieldsForJurisdictionPage: initialJurisdictionFormData,
    updateSchedulesResponse: {
        data: {
            message: '',
        },
    },
    uploadTaxScheduleResponse: {
        data: {},
    },
    uploadDTSchedulePDFResponse: {
        data: {},
        message: '',
    },
    showRadioButton: false,
    isLoaderVisibile: false,
    draftDetailsPage: false,
    draftCoveragePage: false,
    draftApportionmentPage: false,
    uploadJsonVisible: false,
    draftPercentageEdit: false,
    draftInsurersPage: false,
    infoMessageVisible: false,
    errorMessageVisible: false,
    warningMessageVisible: false,
    scheduleWarningVisible: false,
    scheduleWarningMessage: '',
    errorMessage: '',
    insurerValuesOnSubmit: {
        apportionmentMethod: '',
        currency: '',
        layerCount: '',
        insurerDetails: [
            {
                scheduleLayerId: '',
                layerSequence: 0,
                fromValue: '0',
                toValue: '',
                premiumAmt: '',
                insurer: [
                    {
                        isDeleted: false,
                        insurerName: '',
                        coveragePercenage: '',
                        location: '',
                        insurerStatus: [
                            {
                                countryName: '',
                                regionName: '',
                                subRegionName: '',
                                isAdmitted: '',
                                countryCode: '',
                                regionId: null,
                                subRegionId: null,
                            },
                        ],
                        isLeadInsurer: false,
                    },
                ],

                sumAssured: '',
            },
        ],
        localPolicy: [
        {
            layerInsurerId: '',
            insurerSequence: '',
            isDeleted: false,
            taxCalculationRequired: true,
            insuredName: '',
            currency: '',
            insurerName: '',
            insurerLocation: '',
            countryCode: '',
            countryName: '',
            regionId: '',
            regionName: '',
            subRegionId: '',
            subRegionName: '',
            premiumAmount: '',
            isEEAInsurer: false,
            isBranch: null,
        },
    ],
    },
    selectedInsClasses: [],
    selectedRiskLocations: {
        regions : [],
        subRegions : [],
        selectedCountry : '',
        selectedRegion : '',
        selectedSubRegion : '',
    },
    apportionmentTaxData: [],
    selectedSubLob: {} as ClientSubLobs,
    updateVariationApportionment: {} as IResultsResponse,
    updateJurisdictionDetails: {} as IResultsResponse,
    error: {
        errorCode: '',
        errorMessage: '',
    },
    variationApportionmentActiveCountry: '',
    variationApportionmentLocalPolicyActiveCountry: '',
    isNavigateButtonClicked: false,
    variationApportionmentValidation: false,   
    policyCurrency: [],
};
export interface IInsurerStatus {
    countryCode?: string;
    countryName?: string;
    regionName?: string | null;
    regionId?: string | null;
    subRegionId?: string | null;
    subRegionName?: string | null;
    admittedStatus? : string;
    isAdmitted?: string;
    isHide?: boolean;
}
export interface IInsurerDetails {
    scheduleLayerId?: string;
    layerSequence?: number;
    fromValue: string;
    toValue: string;
    premiumAmt: string;
    insurer: IInsurer[];
    sumAssured: string;
}
export interface IInsurer {
    isDeleted: boolean;
    insurerName: string;
    coveragePercenage: string;
    isLeadInsurer: boolean;
    location: string;
    insurerStatus: IInsurerStatus[];
    isEEAInsurer?: boolean;
}
export interface IFormFieldInsurerIdentification {
    apportionmentMethod: string;
    currency: string;
    layerCount: string;
    insurerDetails: IInsurerDetails[];
    localPolicy: ILocalPolicy[];
}

export interface ITaxVariation{
    lobMasterId: string|undefined;
    classId: string|undefined;
    variationId: string;
    coreTaxId: string;
    calculationBasis: string;
    variationApportionment: number;
    inputFields: IInputField;
    isRemoved: boolean;
    premiumAmount: number;
}

export interface IClassTaxVariation{
    classId: string;
    variationId: string;
    coreTaxId: string;
    calculationBasis: string;
    variationApportionment: number;
    inputFields: IInputField;
    isRemoved: boolean;
    premiumAmount: number;
}

export interface IInputField {
    fieldName: string;
    fieldValue: number;
}

export interface ITaxDetails{
    scheduleTaxDetailsId: number;
    taxVariations: ITaxVariation[];    
    taxClassVariations: IClassTaxVariation[];
}

export interface IRiskLocation {
    scheduleLocationDetailsId: number;
    isLocationSaved?: boolean;
    scheduleTaxDetails: ITaxDetails[];
}

export interface IUpdateVariationApportionmentRequest {
    taxScheduleId: number;
    riskLocationDetails: IRiskLocation[];
    shouldUpdateStatus: boolean;
}

export const initialInsurerData = {
    scheduleLayerId: '',
    layerSequence: 0,
    fromValue: '0',
    toValue: '',
    premiumAmt: '',
    insurer: [
        {
            isDeleted: false,
            insurerName: '',
            coveragePercenage: '',
            isLeadInsurer: false,
            location: '',
            insurerStatus: [],
        },
    ],

    sumAssured: '',
};

const initialInsurerDetails = {
    isDeleted: false,
    insurerName: '',
    coveragePercenage: '',
    location: '',
    insurerStatus: [
        {
            countryName: '',
            regionName: '',
            subRegionName: '',
            isAdmitted: '',
        },
    ],
};

const initialLocalPolicyDetails: ILocalPolicy = {
    layerInsurerId: '',
    insurerSequence: '',
    isDeleted: false,
    countryCode: '',
    insuredName: '',
    insurerLocation: '',
    insurerName: '',
    currency: '',
taxCalculationRequired: true,
isEEAInsurer: null,
isBranch: null,
countryName: '',
premiumAmount: '',
regionId: '',
regionName: '',
subRegionId: '',
subRegionName: '',
index: null,
}

export const saveScheduleDetails = createAsyncThunk<IScheduleDetailsResponse, IScheduleRequest>(
    'schedule-details/save-schedule',
    async (data: IScheduleRequest) => {
        return scheduleDetailsServices.saveScheduleDetails(data).then((res) => res);
    },
);

export const getScheduleStatusUpdate = createAsyncThunk<IScheduleStatusResponse, IGetScheduleStatusRequest>(
    'schedule-details/updateTaxScheduleStatus',
    async (data: IGetScheduleStatusRequest) => {
        return scheduleDetailsServices.getScheduleStatusDetails(data).then((res) => res);
    },
);

export const updateVariationApportionment = createAsyncThunk<IResultsResponse, IUpdateVariationApportionmentRequest>(
    'schedule-details/update-variation-apportionment',
    async (data: IUpdateVariationApportionmentRequest) => {
        return scheduleDetailsServices.updateVariationApportionment(data).then((res) => res);
    },
);

export const getScheduleDetails = createAsyncThunk<IScheduleDetailsResponse, IGetScheduleRequest>(
    'schedule-details/get-schedule',
    async (data: IGetScheduleRequest) => {
        return scheduleDetailsServices.getScheduleDetails(data).then((res) => res);
    },
);
export const getScheduleDetailsV2 = createAsyncThunk<IScheduleDetailsV2Response, IGetScheduleRequest>(
    'schedule-details/get-schedule-v2',
    async (data: IGetScheduleRequest) => {
        return scheduleDetailsServices.getScheduleDetailsV2(data).then((res) => res);
    },
);
export const getScheduleTaxBreakup = createAsyncThunk<IScheduleDetailsResponse, IGetScheduleTaxBreakupRequest>(
    'schedule-details/get-schedule-tax-breakup',
    async (data: IGetScheduleTaxBreakupRequest) => {
        return scheduleDetailsServices.getScheduleBreakup(data).then((res) => res);
    },
);

export const getInputFields = createAsyncThunk<InputFieldsResponse, InputFieldsRequestPayload>(
    'schedule-details/get-input-fields',
    async (data: InputFieldsRequestPayload) => {
        return scheduleDetailsServices.getInputFields(data).then((res) => res);
    },
);

export const getCurrencyList = createAsyncThunk<ICurrencyResponse>('schedule-details/get-currencylist', async () => {
    return scheduleDetailsServices.getCurrencyList().then((res) => res);
});

export const getRiskLocationRegions = createAsyncThunk<IRegionsRepsonse, { code: string }>(
    'rate-finder/get-regions',
    async ({ code }) => {
        return rateFinderServices.getRegions([code]).then((res) => res);
    },
);

export const getRiskLocationSubRegions = createAsyncThunk<ISubRegionsRepsonse, { code: string }>(
    'rate-finder/get-sub-regions',
    async ({ code }) => {
        return rateFinderServices.getSubRegions([code]).then((res) => res);
    },
);

export const getScheduleIdFromTaxSchedules = createAsyncThunk<
    IScheduleDetailsPageResponse,
    {
        name?: string;
        description?: string;
        policyNumber?: string;
        policyType?: string;
        effectiveDate?: string | Date;
        expiryDate?: string | Date;
        apportionmentMethod?: string;
        currency?: string;
        layerCount?: string;
        clientLobFlag?: boolean;
        status?: string;
        policyHolderLocation?: string;
        umr?: string;
        clientLobs?: string[];
        insuranceClassIds?: string[];
        insuredName?:string;
    }
>(
    'home-page/task-results',
    async ({
        name,
        description,
        policyNumber,
        policyType,
        policyHolderLocation,
        effectiveDate,
        expiryDate,
        apportionmentMethod,
        currency,
        layerCount,
        clientLobFlag,        
        status,
        umr,
        clientLobs,
        insuranceClassIds,
        insuredName,
    }) => {
        return scheduleDetailsServices
            .postTaxSchedules(
                name,
                description,
                policyNumber,
                policyType,
                effectiveDate,
                expiryDate,
                apportionmentMethod,
                currency,
                layerCount,
                clientLobFlag,
                policyHolderLocation,
                status,
                umr,
                clientLobs,
                insuranceClassIds,
                insuredName,
            )
            .then((res) => {
                return res;
            });
    },
);

export const getListOfScheduleLayerDetails = createAsyncThunk<
    IScheduleLayersResponse,
    {
        scheduleId: string;
        apportionmentMethod: string;
        currency: string;
        layerCount: string;
        layerDetails: ILayerDetailsReq[];
    }
>('home-page/get-schedule-layers', async ({ scheduleId, apportionmentMethod, currency, layerCount, layerDetails }) => {
    return scheduleDetailsServices
        .postScheduleLayers(scheduleId, apportionmentMethod, currency, layerCount, layerDetails)
        .then((res) => {
            return res;
        });
});

export const updateScheduleDetailsStep1 = createAsyncThunk<
    IUpdateScheduleResponse,
    {
        scheduleId: string;
        name?: string;
        description?: string;
        policyNumber?: string;
        policyType?: string;
        effectiveDate?: string | Date;
        expiryDate?: string | Date;
        apportionmentMethod?: string;
        currency?: string;
        layerCount?: string;
        clientLobFlag?: boolean;
        status?: string;
        policyHolderLocation?: string;
        umr?: string;
        clientLobs?: string[];
        insuranceClassIds?: string[];
        insuredName?:string;
    }
>(
    'home-page/update-schedule-details',
    async ({
        scheduleId,
        name,
        description,
        policyNumber,
        policyType,
        policyHolderLocation,
        effectiveDate,
        expiryDate,
        apportionmentMethod,
        currency,
        layerCount,
        clientLobFlag,        
        status,
        umr,
        clientLobs,
        insuranceClassIds,
        insuredName,
    }) => {
        return scheduleDetailsServices
            .updateTaxSchedules(
                scheduleId,
                name,
                description,
                policyNumber,
                policyType,
                effectiveDate,
                expiryDate,
                apportionmentMethod,
                currency,
                layerCount,
                clientLobFlag,
                policyHolderLocation,
                status,
                umr,
                clientLobs,
                insuranceClassIds,
                insuredName,
            )
            .then((res) => {
                return res;
            });
    },
);

export const uploadTaxScheduleJson = createAsyncThunk<IUploadTaxScheduleJsonResponse, IUploadJsonRequest>(
    'schedule-details/upload-tax-schedule-json',
    async (data: IUploadJsonRequest) => {
        // Pass the file and other fields directly to the service
        return scheduleDetailsServices.uploadTaxScheduleJson(data).then((res) => res);
    },
);

export const uploadDTSchedulePDF = createAsyncThunk<IUploadDTSchedulePDFResponse, IUploadDTSchedulePDFRequest>(
    'home-page/upload-dt-schedule-pdf',
    async (data: IUploadDTSchedulePDFRequest) => {
        // Pass the file and other fields directly to the service
        return scheduleDetailsServices.uploadDTSchedulePDF(data).then((res) => res);
    },
);

export const updateApportionmentDetails = createAsyncThunk<IApportionmentResponse, IScheduleRequest>(
    'schedule-details/update-apportionment-details',
    async (data: IScheduleRequest) => {
        return scheduleDetailsServices.updateApportionment(data).then((res) => res);
    },
);

export const updateJurisdictionDetails = createAsyncThunk<IApportionmentResponse, IJurisdictionRequest>(
    'schedule-details/update-jurisdiction-details',
    async (data: IJurisdictionRequest) => {
        return scheduleDetailsServices.updateJurisdictionDetails(data).then((res) => res);
    },
);
export const updateApportionmentDetailsV2 = createAsyncThunk<IApportionmentSaveResponse, IApportionmentSaveRequest>(
    'schedule-details/update-apportionment-details-V2',
    async (data: IApportionmentSaveRequest) => {
        return scheduleDetailsServices.updateApportionmentV2(data).then((res) => res);
    },
);

export const getApportionmentTaxDetails = createAsyncThunk<IApportionmentClientLobResponse, { scheduleId: string }>(
    'schedule-details/get-apportionment-tax-details',
    async ({ scheduleId }) => {
        return scheduleDetailsServices.getApportionmentTaxDetails(scheduleId).then((res) => res);
    },
);

export const updateApportionmentPerLayer = createAsyncThunk<IApportionmentResponse, IApportionmentPerLayerRequest>(
    'schedule-details/update-apportionment-per-layer',
    async (data: IApportionmentPerLayerRequest) => {
        return scheduleDetailsServices.updateApportionmentPerLayer(data).then((res) => res);
    },
);
export const getLobVariationData = createAsyncThunk<ILobVariationResponse, ILobVariationRequest>(
    'schedule-details/get-lob-variation-data',
    async (data: ILobVariationRequest) => {
        return scheduleDetailsServices.getLobVariationData(data).then((res) => res);
    },
);

export const getClassVariationData = createAsyncThunk<IClassVariationResponse, IClassVariationRequest>(
    'schedule-details/get-class-variation-data',
    async (data: IClassVariationRequest) => {
        return scheduleDetailsServices.getClassVariationData(data).then((res) => res);
    },
);
const scheduleDetailsSlice = createSlice({
    name: 'schedule-details',
    initialState,
    extraReducers(builder) {
        builder
            .addCase(saveScheduleDetails.pending, (state) => {
                state.apiState.saveScheduleDetails = ApiState.PENDING;
            })
            .addCase(saveScheduleDetails.fulfilled, (state, action) => {
                state.riskLocationDetails = action.payload.data.riskLocationDetails;
                state.apiState.saveScheduleDetails = ApiState.FULFILLED;
            })
            .addCase(saveScheduleDetails.rejected, (state) => {
                state.apiState.saveScheduleDetails = ApiState.REJECTED;
            })
            .addCase(getCurrencyList.pending, (state) => {
                state.apiState.getCurrencyList = ApiState.PENDING;
            })
            .addCase(getCurrencyList.fulfilled, (state, action) => {
                state.policyCurrency = action.payload.data.currencies;
                state.apiState.getCurrencyList = ApiState.FULFILLED;
            })
            .addCase(getCurrencyList.rejected, (state) => {
                state.apiState.getCurrencyList = ApiState.REJECTED;
            })
            .addCase(updateVariationApportionment.pending, (state) => {
                state.apiState.updateVariationApportionment = ApiState.PENDING;
            })
            .addCase(updateVariationApportionment.fulfilled, (state, action) => {
                state.updateVariationApportionment = { data: action.payload.data };
                state.apiState.updateVariationApportionment = ApiState.FULFILLED;
            })
            .addCase(updateVariationApportionment.rejected, (state) => {
                state.apiState.updateVariationApportionment = ApiState.REJECTED;
            })
            .addCase(getScheduleDetails.pending, (state) => {
                state.apiState.getScheduleDetails = ApiState.PENDING;
            })
            .addCase(getScheduleDetails.fulfilled, (state, action) => {
                state.details = action.payload.data;
                state.apiState.getScheduleDetails = ApiState.FULFILLED;
            })
            .addCase(getScheduleDetails.rejected, (state) => {
                state.apiState.getScheduleDetails = ApiState.REJECTED;
            })
            .addCase(getScheduleDetailsV2.pending, (state) => {
                state.apiState.getScheduleDetailsV2 = ApiState.PENDING;
            })
            .addCase(getScheduleDetailsV2.fulfilled, (state, action) => {
                state.details = action.payload.data;
                state.apiState.getScheduleDetailsV2 = ApiState.FULFILLED;
            })
            .addCase(getScheduleDetailsV2.rejected, (state) => {
                state.apiState.getScheduleDetailsV2 = ApiState.REJECTED;
            })
            .addCase(getScheduleTaxBreakup.pending, (state) => {
                state.apiState.getScheduleTaxBreakup = ApiState.PENDING;
            })
            .addCase(getScheduleTaxBreakup.fulfilled, (state, action) => {
                state.taxBreakup = action.payload.data;
                state.apiState.getScheduleTaxBreakup = ApiState.FULFILLED;
            })
            .addCase(getScheduleTaxBreakup.rejected, (state) => {
                state.apiState.getScheduleTaxBreakup = ApiState.REJECTED;
            })
            .addCase(getScheduleIdFromTaxSchedules.pending, (state) => {
                state.apiState.postTaxSchedules = ApiState.PENDING;
            })
            .addCase(
                getScheduleIdFromTaxSchedules.fulfilled,
                (state, action: PayloadAction<IScheduleDetailsPageResponse>) => {
                    state.scheduleId = action.payload.data.scheduleId;
                    state.apiState.postTaxSchedules = ApiState.FULFILLED;
                },
            )
            .addCase(getScheduleIdFromTaxSchedules.rejected, (state) => {
                state.apiState.postTaxSchedules = ApiState.REJECTED;
            })
            .addCase(getInputFields.pending, (state) => {
                state.apiState.getInputFields = ApiState.PENDING;
            })
            .addCase(getInputFields.fulfilled, (state, action: PayloadAction<InputFieldsResponse>) => {
                state.inputFields = action.payload.data.countries;
                state.apiState.getInputFields = ApiState.FULFILLED;
            })
            .addCase(getInputFields.rejected, (state) => {
                state.apiState.getInputFields = ApiState.REJECTED;
            })
            .addCase(getListOfScheduleLayerDetails.pending, (state) => {
                state.apiState.getScheduleLayerDetails = ApiState.PENDING;
            })
            .addCase(
                getListOfScheduleLayerDetails.fulfilled,
                (state, action: PayloadAction<IScheduleLayersResponse>) => {
                    state.scheduleLayers = [action.payload.data];
                    state.apiState.getScheduleLayerDetails = ApiState.FULFILLED;
                },
            )
            .addCase(getListOfScheduleLayerDetails.rejected, (state) => {
                state.apiState.getScheduleLayerDetails = ApiState.REJECTED;
            })
            .addCase(updateScheduleDetailsStep1.pending, (state) => {
                state.apiState.updateScheduleDetails = ApiState.PENDING;
            })
            .addCase(updateScheduleDetailsStep1.fulfilled, (state, action: PayloadAction<IUpdateScheduleResponse>) => {
                state.updateSchedulesResponse.data = action.payload.data;
                state.apiState.updateScheduleDetails = ApiState.FULFILLED;
            })
            .addCase(updateScheduleDetailsStep1.rejected, (state) => {
                state.apiState.updateScheduleDetails = ApiState.REJECTED;
            })
            .addCase(getScheduleStatusUpdate.pending, (state) => {
                state.apiState.getScheduleStatusUpdate = ApiState.PENDING;
            })
            .addCase(getScheduleStatusUpdate.fulfilled, (state, action: PayloadAction<IUpdateScheduleResponse>) => {
                state.updateSchedulesResponse.data = action.payload.data;
                state.apiState.getScheduleStatusUpdate = ApiState.FULFILLED;
            })
            .addCase(getScheduleStatusUpdate.rejected, (state) => {
                state.apiState.getScheduleStatusUpdate = ApiState.REJECTED;
            })

            .addCase(uploadTaxScheduleJson.pending, (state) => {
                state.apiState.uploadTaxScheduleJson = ApiState.PENDING;
            })
            .addCase(uploadTaxScheduleJson.fulfilled, (state, action) => {
                if (action.payload.error) {
                    if (state.error) {
                        state.error.errorCode = action.payload.error[0].errorCode || '';
                        state.error.errorMessage = action.payload.error[0].errorMessage || '';
                        state.apiState.uploadTaxScheduleJson = ApiState.REJECTED;
                    }
                } else {
                    if (state.uploadTaxScheduleResponse) {
                            state.uploadTaxScheduleResponse.data = action.payload.data;
                        } else {
                            state.uploadTaxScheduleResponse = { data: action.payload.data };
                            }
                state.apiState.uploadTaxScheduleJson = ApiState.FULFILLED;
                                }
            })
            .addCase(uploadTaxScheduleJson.rejected, (state) => {
                state.apiState.uploadTaxScheduleJson = ApiState.REJECTED;
            })
            .addCase(uploadDTSchedulePDF.pending, (state) => {
                state.apiState.uploadDTSchedulePDF = ApiState.PENDING;
            })
            .addCase(uploadDTSchedulePDF.fulfilled, (state, action) => {
                if (action.payload.error) {
                    if (state.error) {
                        state.error.errorCode = action.payload.error.errorCode || '';
                        state.error.errorMessage = action.payload.error.errorMessage || '';
                        state.apiState.uploadDTSchedulePDF = ApiState.REJECTED;
                    }
                } else {
                    if (state.uploadDTSchedulePDFResponse) {
                        state.uploadDTSchedulePDFResponse.data = action.payload.data;
                        state.uploadDTSchedulePDFResponse.message = action.payload.message;
                    }
                    state.apiState.uploadDTSchedulePDF = ApiState.FULFILLED;
                }
            })
            .addCase(uploadDTSchedulePDF.rejected, (state, action) => {
                const payload = action.payload as { error?: { errorCode?: string; errorMessage?: string } } | undefined;
                if (payload && payload.error) {
                    if (state.error) {
                        state.error.errorCode = payload.error.errorCode || '';
                        state.error.errorMessage = payload.error.errorMessage || '';
                        state.apiState.uploadDTSchedulePDF = ApiState.REJECTED;
                    }
                }
                state.apiState.uploadDTSchedulePDF = ApiState.REJECTED;
            })

            

            .addCase(updateApportionmentDetailsV2.pending, (state) => {
                state.apiState.updateApportionmentDetailsV2 = ApiState.PENDING;
            })
            .addCase(updateApportionmentDetailsV2.fulfilled, (state, action) => {
                state.updateSchedulesResponseV2 = action.payload;
                state.apiState.updateApportionmentDetailsV2 = ApiState.FULFILLED;
            })
            .addCase(updateApportionmentDetailsV2.rejected, (state) => {
                state.apiState.updateApportionmentDetailsV2 = ApiState.REJECTED;
            })
            .addCase(updateApportionmentDetails.pending, (state) => {
                state.apiState.updateApportionmentDetails = ApiState.PENDING;
            })
            .addCase(updateApportionmentDetails.fulfilled, (state, action) => {
                state.updateSchedulesResponse.data = action.payload.data;
                state.apiState.updateApportionmentDetails = ApiState.FULFILLED;
            })
            .addCase(updateApportionmentDetails.rejected, (state) => {
                state.apiState.updateApportionmentDetails = ApiState.REJECTED;
            })
            .addCase(updateJurisdictionDetails.pending, (state) => {
                state.apiState.updateJurisdictionDetails = ApiState.PENDING;
            })
            .addCase(updateJurisdictionDetails.fulfilled, (state, action) => {
                state.updateJurisdictionDetails.data = action.payload.data;
                state.apiState.updateJurisdictionDetails = ApiState.FULFILLED;
            })
            .addCase(updateJurisdictionDetails.rejected, (state) => {
                state.apiState.updateJurisdictionDetails = ApiState.REJECTED;
            })
            .addCase(getApportionmentTaxDetails.pending, (state) => {
                state.apiState.getApportionmentTaxDetails = ApiState.PENDING;
            })
            .addCase(getApportionmentTaxDetails.fulfilled, (state, action) => {
                state.apportionmentTaxData = action.payload.data.taxDetails;
                state.apiState.getApportionmentTaxDetails = ApiState.FULFILLED;
            })
            .addCase(getApportionmentTaxDetails.rejected, (state) => {
                state.apiState.getApportionmentTaxDetails = ApiState.REJECTED;
            })
            .addCase(updateApportionmentPerLayer.pending, (state) => {
                state.apiState.updateApportionmentPerLayer = ApiState.PENDING;
            })
            .addCase(updateApportionmentPerLayer.fulfilled, (state) => {
                state.apiState.updateApportionmentPerLayer = ApiState.FULFILLED;
            })
            .addCase(updateApportionmentPerLayer.rejected, (state) => {
                state.apiState.updateApportionmentPerLayer = ApiState.REJECTED;
            })
            .addCase(getLobVariationData.pending, (state) => {
                state.apiState.getLobVariationData = ApiState.PENDING;
            })
            .addCase(getLobVariationData.fulfilled, (state, action) => {
                state.getLobVariationData = action.payload;
                state.apiState.getLobVariationData = ApiState.FULFILLED;
            })
            .addCase(getLobVariationData.rejected, (state) => {
                state.apiState.getLobVariationData = ApiState.REJECTED;
            })
            .addCase(getClassVariationData.pending, (state) => {
                state.apiState.getClassVariationData = ApiState.PENDING;
            })
            .addCase(getClassVariationData.fulfilled, (state, action) => {
                state.getClassVariationData = action.payload;
                state.apiState.getClassVariationData = ApiState.FULFILLED;
            })
            .addCase(getClassVariationData.rejected, (state) => {
                state.apiState.getClassVariationData = ApiState.REJECTED;
            })
            .addCase(getRiskLocationRegions.pending, (state) => {
                state.apiState.getRiskLocationRegions = ApiState.PENDING;
            })
            .addCase(getRiskLocationRegions.fulfilled, (state, action) => {
                state.apiState.getRiskLocationRegions = ApiState.FULFILLED;
                state.selectedRiskLocations.regions = action.payload.data.countries[0].regions;                
            })
            .addCase(getRiskLocationRegions.rejected, (state) => {
                state.apiState.getRiskLocationRegions = ApiState.REJECTED;
            })
            .addCase(getRiskLocationSubRegions.pending, (state) => {
                state.apiState.getRiskLocationSubRegions = ApiState.PENDING;
            })
            .addCase(getRiskLocationSubRegions.fulfilled, (state, action) => {
                state.apiState.getRiskLocationSubRegions = ApiState.FULFILLED;
                state.selectedRiskLocations.subRegions = action.payload.data.regions[0].subRegions;                
            })
            .addCase(getRiskLocationSubRegions.rejected, (state) => {
                state.apiState.getRiskLocationSubRegions = ApiState.REJECTED;
            });
    },  
    reducers: {
        resetSaveDetailsApiState(state) {
            state.apiState.saveScheduleDetails = ApiState.NOT_STARTED;
        },
        resetPostTaxScheduleApiState(state) {
            state.apiState.postTaxSchedules = ApiState.NOT_STARTED;
        },
        resetUpdateScheduleLayersApiState(state) {
            state.apiState.updateScheduleDetails = ApiState.NOT_STARTED;
        },
        resetPostScheduleLayersApiState(state) {
            state.apiState.getScheduleLayerDetails = ApiState.NOT_STARTED;
        },
        resetUpdateJurisdictionDetails(state) {
            state.apiState.updateJurisdictionDetails = ApiState.NOT_STARTED;
        },
        setFormFieldsScheduleDetails: (state, action: PayloadAction<{ field: keyof IFormField; value: string }>) => {
            if (action.payload.field === 'lob') {
                state.formFields.lob = action.payload.value ? action.payload.value.split(',').map(s => s.trim()) : [];
            } else if( action.payload.field === 'class') {
                state.formFields.class = action.payload.value ? action.payload.value.split(',').map(s => s.trim()) : [];
            } else {
                state.formFields[action.payload.field] = action.payload.value;
            }
        },
        setFormFieldForstepOneOnSubmit: (state) => {
            state.formValueOnStepOneSubmit = { ...state.formValueOnStepOneSubmit, ...state.formFields };
        },
        resetFormFields: (state) => {
            state.details = {};
            state.formFields = initialState.formFields;
            state.formValueOnStepOneSubmit = initialState.formValueOnStepOneSubmit;
            state.scheduleId = 0;
        },
        updateLocationData: (state, action: PayloadAction<ILocationData[]>) => {
            state.locationDetails = action.payload;
        },
        preloadData: (state) => {
            const scheduleDetails = state.details?.scheduleDetails;
            state.formFields.name = scheduleDetails.scheduleName;
            state.formFields.description = scheduleDetails.description;
            state.formFields.policyNumber = scheduleDetails.policyNumber;
            state.formFields.umr = scheduleDetails.policyType;
            state.formFields.currency = scheduleDetails.currency;
            state.formFields.policyHolderLocation = scheduleDetails.policyHolderLocation;
            state.formFields.effectiveDate = format(new Date(scheduleDetails.effectiveDate), 'yyyy-MM-dd');
            state.formFields.expiryDate = format(new Date(scheduleDetails.expiryDate), 'yyyy-MM-dd');
            state.scheduleId = scheduleDetails.taxScheduleId;
            state.formFields.lob = Array.isArray(scheduleDetails.clientLob)
                    ? scheduleDetails.clientLob.map((lob: { lobMasterId: string }) => String(lob.lobMasterId))
                    : [];
            state.formFields.class = Array.isArray(scheduleDetails.insClasses)
                    ? scheduleDetails.insClasses.map((cls: { classId: string }) => String(cls.classId))
                    : [];
            const riskLocationDetails = state.details?.riskLocationDetails || [];
            if (riskLocationDetails.length > 0) {
                state.jurisdictionDetails = riskLocationDetails.filter((loc: any) => loc.isLocalPolicy === false).map((location: IRiskLocationDetailsResponse) => ({
                    ...location,
                    isDeleted: false,
                    scheduleLocationDetailsId: location.scheduleLocationId,
                    countryCode: location.countryCode,
                    isGermanEEA: location.isGermanEEA,
                    regionId: location.regionId || null,
                    subRegionId: location.subRegionId || null,
                    regionName: location.regionName || null,
                    subRegionName: location.subRegionName || null,
                    insClassVariations: location.insClassVariations,
                    isNewlyAddedRiskLocationCountry : location.isNewlyAddedRiskLocationCountry,
                }));
            }
        },
        setFormFields: (
            state,
            action: PayloadAction<{
                field: keyof Omit<IFormFieldInsurerIdentification, 'insurerDetails' | 'localPolicy'>;
                value: string;
            }>,
        ) => {
                state.formFieldsForJurisdictionPage[action.payload.field] = action.payload.value;
            

            if (action.payload.field === 'layerCount') {
                const newLayerCount = parseInt(action.payload.value, 10); // Ensure the value is an integer
                const currentLayerCount = state.formFieldsForJurisdictionPage.insurerDetails.length;
                if (newLayerCount < currentLayerCount) {
                    // If the new layer count is less than the current count, remove the excess insurerDetails
                    state.formFieldsForJurisdictionPage.insurerDetails =
                        state.formFieldsForJurisdictionPage.insurerDetails.slice(0, newLayerCount);
                } else if (newLayerCount > currentLayerCount) {
                    for (let i = currentLayerCount; i < newLayerCount; i++) {
                        const insurerData = { ...initialInsurerData, insurerStatus: [] };
                        insurerData.fromValue =
                            i === 0 ? '0' : state.formFieldsForJurisdictionPage.insurerDetails[i - 1].toValue;
                        state.formFieldsForJurisdictionPage.insurerDetails.push({ ...insurerData });
                    }
                }
            }
        },
        setSubFormFields: (
            state,
            action: PayloadAction<{
                field: keyof Pick<IFormFieldInsurerIdentification, 'insurerDetails'>;
                subField: keyof IInsurerDetails;
                index: number;
                value: string | number;
            }>,
        ) => {
            if (state.formFieldsForJurisdictionPage[action.payload.field][action.payload.index]) {
                const oldValue = state.formFieldsForJurisdictionPage[action.payload.field][action.payload.index];
                state.formFieldsForJurisdictionPage[action.payload.field][action.payload.index] = oldValue;
                // Type assertion to allow assignment
                (state.formFieldsForJurisdictionPage[action.payload.field][action.payload.index] as any)[
                    action.payload.subField
                ] = action.payload.value;
            }
            const { value, index, subField } = action.payload;
            if (subField === 'toValue' && typeof index === 'number') {
                const insurerDetails = state.formFieldsForJurisdictionPage.insurerDetails;
                const newToValue = 0;
                insurerDetails[index].toValue = value as string;

                const fromValueCurrent =
                    index > 0 ? 0 : 0;
                const sumAssuredCurrent = newToValue - fromValueCurrent;
                insurerDetails[index].sumAssured = !isNaN(sumAssuredCurrent) ? sumAssuredCurrent.toString() : '0';

                for (let i = index + 1; i < insurerDetails.length; i++) {
                    insurerDetails[i].fromValue = insurerDetails[i - 1].toValue;
                    const fromValueNext = 0;
                    const toValueNext = 0;
                    const sumAssuredNext = toValueNext - fromValueNext;
                    insurerDetails[i].sumAssured = !isNaN(sumAssuredNext) ? sumAssuredNext.toString() : '0';
                }
            }
        },
        setLocalPolicyDetails: (
            state,
            action: PayloadAction<{
                index: number;
                field: keyof Omit<ILocalPolicy, 'isDeleted' | 'taxCalculationRequired' | 'index' | 'isBranch' | 'isEEAInsurer'>;
                value: string;
            }>,
        ) => {
            state.formFieldsForJurisdictionPage.localPolicy[action.payload.index][action.payload.field]
             = action.payload.value;
        },
        setInsurerDetails: (
            state,
            action: PayloadAction<{
                index: number;
                field: keyof Omit<IInsurer, 'insurerStatus' | 'isDeleted' | 'isEEAInsurer' | 'isLeadInsurer'>;
                value: string;
                subIndex: number;
            }>,
        ) => {
            (state.formFieldsForJurisdictionPage.insurerDetails[action.payload.index].insurer[action.payload.subIndex] as any)[
                action.payload.field
            ] = action.payload.value;
        },
        setIsEEAInsurer: (
            state,
            action: PayloadAction<{
                index: number;
                subIndex: number;
                value: boolean;
            }>,
        ) => {
            state.formFieldsForJurisdictionPage.insurerDetails[action.payload.index].insurer[action.payload.subIndex].isEEAInsurer
                = action.payload.value;
        },
        removeEmptyInsurer: (state) => {
            state.formFieldsForJurisdictionPage.insurerDetails[0].insurer = state.formFieldsForJurisdictionPage.insurerDetails[0].insurer.filter(insurer => { 
const isEmpty = !insurer.insurerName?.trim() &&
                !insurer.coveragePercenage?.trim() &&
                !insurer.location?.trim() &&
                (!insurer.insurerStatus || insurer.insurerStatus.length === 0);
        return !isEmpty;
            });
        },
        addInsurerDetails: (state, action: PayloadAction<number>) => {
            const jurisdictionIndex = action.payload;
            const insurers = state.formFieldsForJurisdictionPage.insurerDetails[jurisdictionIndex].insurer;
            if (insurers.length < 15) {
                insurers.push({
                    ...initialInsurerDetails, insurerStatus: [],
                    isLeadInsurer: false,
                });
                if (insurers.length > 1) {
                    state.formFieldsForJurisdictionPage.insurerDetails[jurisdictionIndex].insurer = insurers.map(
                        (insurer) => ({
                            ...insurer,
                            // coveragePercenage: '', // Reset coverage percentage
                        }),
                    );
                }
            }
        },
        addLocalPolicyDetails: (state) => {
            const localPolicy = state.formFieldsForJurisdictionPage.localPolicy;
            const initialLocalPolicyDetailsCopy = { ...initialLocalPolicyDetails };
            initialLocalPolicyDetailsCopy.index = localPolicy.length;
            if (localPolicy.length < 15) {
                localPolicy.push(initialLocalPolicyDetailsCopy);                
            }
        },
        removeEmptyLocalPolicy: (state) => {
            state.formFieldsForJurisdictionPage.localPolicy = state.formFieldsForJurisdictionPage.localPolicy.filter(policy => {        
        
        // Check if all relevant fields are empty/null
        const isEmpty = !policy.layerInsurerId?.trim() &&
                       !policy.insurerSequence?.trim() &&
                       !policy.insuredName?.trim() &&
                       !policy.currency?.trim() &&
                       !policy.insurerName?.trim() &&
                       !policy.insurerLocation?.trim() &&
                       !policy.countryCode?.trim() &&
                       !policy.countryName?.trim() &&
                       !policy.regionId?.trim() &&
                       !policy.regionName?.trim() &&
                       !policy.subRegionId?.trim() &&
                       !policy.subRegionName?.trim() &&
                       !policy.premiumAmount?.trim();
        
        return !isEmpty;
    });
        },
        removeLocalPolicyDetails: (state, action: PayloadAction<number>) => {
            const localPolicyIndex = action.payload;
            const localPolicy = state.formFieldsForJurisdictionPage.localPolicy[localPolicyIndex];
            if (localPolicy) {
                // if(localPolicy.layerInsurerId)
                localPolicy.isDeleted = true;                
            }
        },
        removeInsurerDetails: (state, action: PayloadAction<{ index: number; subIndex: number }>) => {
            const { index, subIndex } = action.payload;
            state.formFieldsForJurisdictionPage.insurerDetails[index].insurer[subIndex].isDeleted = true;
            state.formFieldsForJurisdictionPage.insurerDetails[index].insurer[subIndex].coveragePercenage = '';
            state.formFieldsForJurisdictionPage.insurerDetails[index].insurer[subIndex].insurerStatus = [];
            //const insurerDetails = state.formFieldsForJurisdictionPage.insurerDetails[index];
            //const remainingInsurers = insurerDetails.insurer.filter((insurer) => !insurer.isDeleted).length;
            // if (remainingInsurers === 1) {
            //     const remainingInsurer = insurerDetails.insurer.find((insurer) => !insurer.isDeleted);
            //     if (remainingInsurer) {
            //         remainingInsurer.coveragePercenage = '100';
            //     }
            // }
            // if (remainingInsurers > 1) {
            //     insurerDetails.insurer.forEach((insurer) => {
            //         if (!insurer.isDeleted) {
            //             insurer.coveragePercenage = '';
            //         }
            //     });
            // }
        },
        resetFormFieldsForStep3: (state) => {
            state.formFieldsForJurisdictionPage = initialState.formFieldsForJurisdictionPage;
        },
        resetStep3Data: (state) => {
            state.insurerValuesOnSubmit = initialState.formFieldsForJurisdictionPage;
            state.scheduleLayers = [];
        },
        setInsurerStatus: (
            state,
            action: PayloadAction<{
                field: keyof Pick<IInsurer, 'insurerStatus'>;
                index: number;
                value: IInsurerStatus[];
                subIndex: number;
            }>,
        ) => {
            if (state.formFieldsForJurisdictionPage.insurerDetails[action.payload.index].insurer) {
                state.formFieldsForJurisdictionPage.insurerDetails[action.payload.index].insurer[
                    action.payload.subIndex
                ].insurerStatus = action.payload.value;
            }
        },
        setLocalPolicyTaxCalReq: (
            state,
            action: PayloadAction<{
                field: keyof Pick<ILocalPolicy, 'taxCalculationRequired'>;
                index: number;
                value: boolean;
            }>,
        ) => {            
                state.formFieldsForJurisdictionPage.localPolicy[action.payload.index].taxCalculationRequired
                 = action.payload.value;            
        },
        setLocalPolicyBoolean: (
            state,
            action: PayloadAction<{
                field: keyof Pick<ILocalPolicy, 'isBranch' | 'isEEAInsurer'>;
                index: number;
                value: boolean;
            }>,
        ) => {            
                state.formFieldsForJurisdictionPage.localPolicy[action.payload.index][action.payload.field]
                 = action.payload.value;            
        },
        setApportionmentInputDetails: (state, action: PayloadAction<ICountryData[]>) => {
            state.apportionmentInputDetails = action.payload;
        },
        setVariationApportionment: (state, action: PayloadAction<IUpdateVariationApportionmentRequest>) => {
            state.variationApportionment = action.payload;
        },
        setVariationApportionmentUI:(state, action: PayloadAction<IApportionmentData>)=>{
            state.apportionmentDetails = action.payload;
        },
        setApportionmentData: (state, action: PayloadAction<IApportionmentData>) => {
            state.apportionmentData = action.payload;
        },
        setLocalPolicyApportionmentData: (state, action: PayloadAction<IApportionmentData>) => {
            state.localPolicyApportionmentData = action.payload;
        },
        setApportionmentAccordianOpen: (state, action: PayloadAction<boolean[]>) => {
            state.isApportionmentAccordianOpen = action.payload;
        },
        resetApportionmentData(state) {
            state.apportionmentDetails = {} as IApportionmentData;
            state.apportionmentClientLobDetails = {} as IClientLobApportionmentData;
            state.apportionmentInputDetails = [];
            state.inputFields = [];
            state.isApportionmentAccordianOpen = [];
            state.apportionmentTaxData = [];
        },
        removeRiskLocations(state, action: PayloadAction<string>) {
            state.riskLocationDetails = state.riskLocationDetails.filter(
                (risk) => risk.scheduleLocationId !== action.payload,
            );
        },
        updateCountry(state, action: PayloadAction<{ index: number; code: string }>) {
            if (state.riskLocationDetails[action.payload.index]) {
                state.riskLocationDetails[action.payload.index].countryCode = action.payload.code;
                state.riskLocationDetails[action.payload.index].regionName = null;
                state.riskLocationDetails[action.payload.index].subRegionName = null;
            }
        },        
        updateScheduleLocationDetailsId(state, action: PayloadAction<{ index: number; code: string }>) {
            if (state.riskLocationDetails[action.payload.index]) {
                state.riskLocationDetails[action.payload.index].scheduleLocationId = action.payload.code;
            }
        },
        updateLocationDataRegion(state, action: PayloadAction<{ index: number; code: string }>) {
            if (state.locationDetails[action.payload.index]) {
                state.riskLocationDetails[action.payload.index].regionName = action.payload.code;
                state.riskLocationDetails[action.payload.index].subRegionName = null;
            }
        },
        updateRegion(state, action: PayloadAction<{ index: number; code: string }>) {
            if (state.riskLocationDetails[action.payload.index]) {
                state.riskLocationDetails[action.payload.index].regionName = action.payload.code;
                state.riskLocationDetails[action.payload.index].subRegionName = null;
            }
        },
        updateSubRegion(state, action: PayloadAction<{ index: number; code: string }>) {
            if (state.riskLocationDetails[action.payload.index]) {
                state.riskLocationDetails[action.payload.index].subRegionName = action.payload.code;
            }
        },
        resetStep2Data(state) {
            state.locationDetails = initialState.locationDetails;
            state.riskLocationDetails = initialState.riskLocationDetails;
        },
        setRadioButton: (state, action: PayloadAction<boolean>) => {
            state.showRadioButton = action.payload;
        },
        setIsLoaderVisible: (state, action: PayloadAction<boolean>) => {
            state.isLoaderVisibile = action.payload;
        },
        setDraftDetailsPage: (state, action: PayloadAction<boolean>) => {
            state.draftDetailsPage = action.payload;
        },
        setDraftCoveragePage: (state, action: PayloadAction<boolean>) => {
            state.draftCoveragePage = action.payload;
        },
        setDraftInsurersPage: (state, action: PayloadAction<boolean>) => {
            state.draftInsurersPage = action.payload;
        },
        setDraftApportionmentPage: (state, action: PayloadAction<boolean>) => {
            state.draftApportionmentPage = action.payload;
        },
        setUploadJsonVisible: (state, action: PayloadAction<boolean>) => {
            state.uploadJsonVisible = action.payload;
        },
        setDraftPercentageEdit: (state, action: PayloadAction<boolean>) => {
            state.draftPercentageEdit = action.payload;
        },
        setInfoMessageVisible: (state, action: PayloadAction<boolean>) => {
            state.infoMessageVisible = action.payload;
        },        
        setErrorMessageVisible: (state, action: PayloadAction<boolean>) => {
            state.errorMessageVisible = action.payload;
        },
        setWarningMessageVisible: (state, action: PayloadAction<boolean>) => {
            state.warningMessageVisible = action.payload;
        },
        setScheduleWarningVisible: (state, action: PayloadAction<boolean>) => {
            state.scheduleWarningVisible = action.payload;
        },
        setscheduleWarningMessage: (state, action: PayloadAction<string>) => {
            state.scheduleWarningMessage = action.payload;
        },
        setErrorMessageContent: (state, action: PayloadAction<string>) => {
            state.errorMessage = action.payload;
        },
        setNavigateButtonClicked: (state, action: PayloadAction<boolean>) => {
            state.isNavigateButtonClicked = action.payload;
        },
        setVariationApportionmentValidation(state, action: PayloadAction<boolean>){
            state.variationApportionmentValidation = action.payload;
        },
        saveInsurerValuesOnSubmit: (state) => {
            state.insurerValuesOnSubmit = { ...state.insurerValuesOnSubmit, ...state.formFieldsForJurisdictionPage };
        },
        setInsurerData: (state) => {
            state.formFieldsForJurisdictionPage = state.insurerValuesOnSubmit;
        },
        setJusristictionData(state, action: PayloadAction<IFormFieldInsurerIdentification>) {
            state.formFieldsForJurisdictionPage = action.payload;
        },
        saveApportionmentData(state, action: PayloadAction<IApportionmentData>) {
            state.apiState.updateApportionmentDetails = ApiState.NOT_STARTED;
            state.apportionmentDetails = action.payload;
        },
        resetSaveApportionmentData(state){
            state.apiState.updateApportionmentDetails = ApiState.NOT_STARTED;
        },
        resetApiStateScheduleOutput(state) {
            state.apiState.getScheduleTaxBreakup = initialState.apiState.getScheduleTaxBreakup;
            state.apiState.getScheduleDetails = initialState.apiState.getScheduleDetails;
        },
        setSelectedInsClasses(state, action: PayloadAction<IClassInputDetails[]>) {
            state.selectedInsClasses = action.payload;
        },
        setSelectedRiskLocationCountry(state, action: PayloadAction<string>) {
            state.selectedRiskLocations.selectedCountry = action.payload;
        },
        setSelectedRiskLocationRegion(state, action: PayloadAction<string>) {
            state.selectedRiskLocations.selectedRegion = action.payload;
        },
        setSelectedRiskLocationSubRegion(state, action: PayloadAction<string>) {
            state.selectedRiskLocations.selectedSubRegion = action.payload;
        },
        setRiskLocationRegions(state, action: PayloadAction<IRegions[]>) {
            state.selectedRiskLocations.regions = action.payload;
        },
        setRiskLocationSubRegions(state, action: PayloadAction<ISubRegions[]>) {
            state.selectedRiskLocations.subRegions = action.payload;
        },
        resetSelectedRiskLocation(state) {
            state.selectedRiskLocations = initialState.selectedRiskLocations;
        },
        setSelectedSublobs(state, action: PayloadAction<ClientSubLobs>) {
            state.selectedSubLob = action.payload;
        },
        saveClientLobApportionmentData(state, action: PayloadAction<IClientLobApportionmentData>) {
            state.apiState.updateApportionmentDetails = ApiState.NOT_STARTED;
            state.apportionmentClientLobDetails = action.payload;
        },
        setVariationApportionmentActiveCountry(state,action: PayloadAction<string>){
            state.variationApportionmentActiveCountry=action.payload;
        },
        setVariationApportionmentLocalPolicyActiveCountry(state,action: PayloadAction<string>){
            state.variationApportionmentLocalPolicyActiveCountry=action.payload;
        },
        resetToastMsgUploadDTSchedulePDF(state) {
            state.apiState.uploadDTSchedulePDF = ApiState.NOT_STARTED;
            state.uploadDTSchedulePDFResponse = initialState.uploadDTSchedulePDFResponse;
        },
        setErrorMessage(state, action: PayloadAction<{ errorCode: string; errorMessage: string }>) {
            state.error = {
                errorCode: action.payload.errorCode,
                errorMessage: action.payload.errorMessage,
            };
        },
        resetErrorState(state) {
            state.apiState.saveScheduleDetails = ApiState.NOT_STARTED;
            state.apiState.postTaxSchedules = ApiState.NOT_STARTED;
            state.apiState.updateScheduleDetails = ApiState.NOT_STARTED;
            state.apiState.updateApportionmentDetails = ApiState.NOT_STARTED;      
            state.apiState.updateVariationApportionment = ApiState.NOT_STARTED;
            state.apiState.updateJurisdictionDetails = ApiState.NOT_STARTED;
            state.error = initialState.error; 
        },
    },
});

export const {
    setFormFieldsScheduleDetails,
    resetFormFields,
    resetSaveDetailsApiState,
    resetUpdateJurisdictionDetails,
    updateLocationData,
    preloadData,
    setFormFields,
    resetFormFieldsForStep3,
    setSubFormFields,
    addInsurerDetails,    
    setInsurerStatus,
    setInsurerDetails,
    setIsEEAInsurer,
    removeEmptyInsurer,
    removeInsurerDetails,
    addLocalPolicyDetails,
    removeEmptyLocalPolicy,
    removeLocalPolicyDetails,
    setLocalPolicyDetails,
    setLocalPolicyTaxCalReq,
    setLocalPolicyBoolean,
    resetPostTaxScheduleApiState,
    resetPostScheduleLayersApiState,
    setFormFieldForstepOneOnSubmit,
    resetUpdateScheduleLayersApiState,
    setApportionmentInputDetails,
    setVariationApportionment,
    setVariationApportionmentUI,
    setApportionmentData,
    setLocalPolicyApportionmentData,
    setApportionmentAccordianOpen,
    resetApportionmentData,
    removeRiskLocations,
    updateCountry,
    updateScheduleLocationDetailsId,
    updateRegion,
    updateSubRegion,
    resetStep2Data,
    setRadioButton,
    setIsLoaderVisible,
    setDraftDetailsPage,
    setDraftCoveragePage,
    setDraftInsurersPage,
    setDraftApportionmentPage,
    setUploadJsonVisible,
    setInfoMessageVisible,
    setErrorMessageVisible,
    setWarningMessageVisible,
    setScheduleWarningVisible,
    setscheduleWarningMessage,
    setErrorMessageContent,
    saveInsurerValuesOnSubmit,
    setInsurerData,
    setJusristictionData,
    saveApportionmentData,
    resetSaveApportionmentData,
    resetApiStateScheduleOutput,
    setSelectedInsClasses,
    setSelectedRiskLocationCountry,
    setSelectedRiskLocationRegion,
    setSelectedRiskLocationSubRegion,
    setRiskLocationRegions,
    setRiskLocationSubRegions,
    resetSelectedRiskLocation,
    setSelectedSublobs,
    saveClientLobApportionmentData,
    resetStep3Data,
    setDraftPercentageEdit,
    setVariationApportionmentActiveCountry,    
    setVariationApportionmentLocalPolicyActiveCountry,
    resetToastMsgUploadDTSchedulePDF,
    setErrorMessage,
    resetErrorState,
    setNavigateButtonClicked,
    setVariationApportionmentValidation,
} = scheduleDetailsSlice.actions;
export default scheduleDetailsSlice.reducer;
